import { render, staticRenderFns } from "./CollectionsCarouselHost.vue?vue&type=template&id=8056ea88"
import script from "./CollectionsCarouselHost.vue?vue&type=script&lang=js"
export * from "./CollectionsCarouselHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports